bovoApp.controller('OldOrderController', ['$scope',
	function ($scope){

        $scope.init = function(){
            console.log('1231313123123');
        }

    }
]);